export default __webpack_public_path__ + "ee09d54a82c351d24d4e58b34ad81cec.png";